export default "__VITE_ASSET__CjImv3Tb__"